import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import LoginPage from './pages/LoginPage'
import ProspectsPage from './pages/ProspectsPage'
import ImportPage from './pages/ImportPage'
import CampaignsPage from './pages/CampaignsPage'
import WarmProspectsPage from './pages/WarmProspectsPage'
import DashboardPage from './pages/DashboardPage'
import MailAgentsPage from './pages/MailAgentsPage'

function PrivateRoute({ children }) {
  const { isAuthed } = useAuth()
  return isAuthed ? children : <Navigate to="/login" replace />
}

function PublicRoute({ children }) {
  const { isAuthed } = useAuth()
  return !isAuthed ? children : <Navigate to="/" replace />
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/" element={<PrivateRoute><ProspectsPage /></PrivateRoute>} />
      <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
      <Route path="/import" element={<PrivateRoute><ImportPage /></PrivateRoute>} />
      <Route path="/campaigns" element={<PrivateRoute><CampaignsPage /></PrivateRoute>} />
      <Route path="/warm" element={<PrivateRoute><WarmProspectsPage /></PrivateRoute>} />
      <Route path="/mail-agents" element={<PrivateRoute><MailAgentsPage /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  )
}